/** @deprecated Old global key — leaked drafts across accounts; removed on read/write/logout */
const LEGACY_DRAFT_KEY = 'reeco.drawing.draft.v1'

/**
 * Per-user draft so switching accounts never shows another user's canvas.
 * @param {number | string | null | undefined} userId
 */
export function drawingDraftStorageKey(userId) {
  if (userId == null || userId === '') return null
  return `reeco.drawing.draft.v1.u${userId}`
}

export function purgeLegacyDrawingDraft() {
  if (typeof window === 'undefined') return
  try {
    localStorage.removeItem(LEGACY_DRAFT_KEY)
  } catch {
    /* ignore */
  }
}

/**
 * Persist canvas so reload keeps the drawing (Fabric JSON + PNG for submit).
 * Requires a logged-in user id — avoids saving to a global key shared by all accounts.
 */
export function saveDrawingDraft({ fabricJSON, dataURL, userId }) {
  if (typeof window === 'undefined') return
  const key = drawingDraftStorageKey(userId)
  if (!key) return
  try {
    purgeLegacyDrawingDraft()
    const payload = JSON.stringify({
      fabricJSON,
      dataURL,
      savedAt: Date.now(),
    })
    localStorage.setItem(key, payload)
  } catch (e) {
    /* quota / private mode */
    console.warn('Could not save drawing draft:', e)
  }
}

export function loadDrawingDraft(userId) {
  if (typeof window === 'undefined') return null
  try {
    purgeLegacyDrawingDraft()
    const key = drawingDraftStorageKey(userId)
    if (!key) return null
    const raw = localStorage.getItem(key)
    if (!raw) return null
    const data = JSON.parse(raw)
    if (!data || typeof data.fabricJSON !== 'string' || typeof data.dataURL !== 'string') {
      return null
    }
    return data
  } catch {
    return null
  }
}

/**
 * Remove draft for one user and always drop the legacy global key.
 * @param {number | string | null | undefined} userId
 */
export function clearDrawingDraft(userId) {
  if (typeof window === 'undefined') return
  try {
    purgeLegacyDrawingDraft()
    const key = drawingDraftStorageKey(userId)
    if (key) localStorage.removeItem(key)
  } catch {
    /* ignore */
  }
}

/** Call when logging out: clear the signed-out user's draft and any legacy blob. */
export function clearDrawingDraftOnLogout(userId) {
  clearDrawingDraft(userId)
}
